<h5>Question Sets</h5>
<div [style.minHeight]="'40vh'">
  <h6 *ngIf="!questionSets || questionSets.length === 0" class="no-sets">
    No question sets found.
    <small>Click on Add Set to create one.</small>
  </h6>

  <div class="question-set" *ngFor="let set of questionSets; let idx = index">
    <div class="title-row" fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
      <div class="field-col">
        <mat-form-field appearance="outline" class="title-field">
          <mat-label>Set Title</mat-label>
          <input matInput [(ngModel)]="set.title" placeholder="e.g. Competitors">
          <mat-error *ngIf="isDuplicateTitle(idx)">Title must be unique</mat-error>
        </mat-form-field>
        <small class="set-error" *ngIf="isDuplicateTitle(idx)">
          Duplicate title - titles must be unique.
        </small>
      </div>
      <i class="fa fa-trash" (click)="removeSet(idx)"></i>
    </div>

    <div class="values-wrap">
      <label class="values-label">Values</label>
      <div class="value-row" fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center"
        *ngFor="let value of set.values; let vIdx = index; trackBy: trackByIndex">
        <mat-form-field class="value-field">
          <mat-label>Value</mat-label>
          <input matInput [(ngModel)]="set.values[vIdx]">
        </mat-form-field>
        <i class="fa fa-trash" (click)="removeValue(set, vIdx)"></i>
      </div>
      <button mat-stroked-button class="mat-green add-value-btn" (click)="addValue(set)" matTooltip="Add Value">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <hr />
  </div>

  <div fxLayout="row wrap" class="settings-row add-set-row" fxLayoutGap="10px">
    <button mat-raised-button class="mat-primary" (click)="addSet()">Add Set</button>
  </div>
</div>
